export default __webpack_public_path__ + "static/media/sketch_world_cup_banner.75340da7.jpg";